import GenericActionButton from 'src/components/GenericActionButton';
import { useState } from 'react';
import CustomSnackBar from 'src/components/CustomSnackBar';
import { ERROR_SEVERITY, SEVERITY_TYPE, SUCCESS_SEVERITY } from 'src/components/CustomSnackBar/interfaces';
import amplitudeEventTracker from 'src/analitycs/index';
import { CSV_FILE_DOWNLOADED } from 'src/analitycs/pagesEvents/transactions';

import { styles } from './styles';

// Provisional, PTMQRVA-1396: tiene que coincidir con el tope del backend, que
// es quien lo aplica. Este numero solo decide si la descarga aviso que corto.
const TRANSACTIONS_DOWNLOAD_AMOUNT = 400;

interface IComponentDownloadCSV {
    /** Devuelve el CSV ya armado por el backend. */
    handleDownload: () => Promise<string>;
    fileName: string;
    disabled?: boolean;
}

/**
 * El backend entrega el archivo CSV completo, asi que el navegador solo lo baja.
 * Antes el texto se pasaba a una libreria que arma CSVs a partir de filas y el
 * click se disparaba antes de que el contenido estuviera aplicado: la primera
 * descarga salia vacia y la siguiente traia la anterior, siempre con cartel de
 * exito. Bajando el texto directo no queda estado intermedio que desfasarse.
 */
const DownloadCSVButton = ({
  handleDownload,
  fileName,
  disabled = false
}: IComponentDownloadCSV) => {

  const { classes } = styles();
  const [isLoading, setIsLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [snackBarSeverity, setSnackBarSeverity] = useState<SEVERITY_TYPE>(SUCCESS_SEVERITY);
  const [reachedLimit, setReachedLimit] = useState(false);

  const saveFile = (csv: string) => {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const download = async () => {
    setIsLoading(true);
    setShowToast(false);
    try {
        const csv = await handleDownload();

        // Sin filas el backend devuelve solo los encabezados: conviene avisar
        // en vez de bajar un archivo que el comercio abre y encuentra vacio.
        if (!csv || csv.trim().split('\n').length < 2) {
            setSnackBarSeverity(ERROR_SEVERITY);
            return;
        }

        // El tope solo se menciona cuando se alcanzo: avisarlo en cada descarga
        // hacia dudar de un archivo que estaba completo.
        const rows = csv.trim().split('\n').length - 1;
        setReachedLimit(rows >= TRANSACTIONS_DOWNLOAD_AMOUNT);

        saveFile(csv);
        setSnackBarSeverity(SUCCESS_SEVERITY);
        amplitudeEventTracker.logEvent(CSV_FILE_DOWNLOADED);
    } catch (error) {
        setSnackBarSeverity(ERROR_SEVERITY);
    } finally {
        setShowToast(true);
        setIsLoading(false);
    }
  }

  const getSnackBarTitleBySeverity = () => {
    return snackBarSeverity === SUCCESS_SEVERITY ? '¡Listo! Descargaste el detalle de tus transacciones' : 'Ocurrió un error';
  }

  const getSnackBarSubtitleBySeverity = () => {
    if (snackBarSeverity !== SUCCESS_SEVERITY) return 'El detalle de las transacciones no pudo ser descargado.';

    return reachedLimit ? `El archivo trae las primeras ${TRANSACTIONS_DOWNLOAD_AMOUNT} transacciones del filtro aplicado.` : '';
  }

  return (
    <>
        <GenericActionButton
            className={classes.downloadButton}
            label={isLoading ? 'Descargando CSV...' : 'Descargar CSV'}
            onClick={download}
            type='button'
            isLoading={isLoading || disabled}
            testId={'download-button'}
        />
        <CustomSnackBar showSnackbar={showToast} duration={5000} severity={snackBarSeverity} title={getSnackBarTitleBySeverity()} subtitle={getSnackBarSubtitleBySeverity()}/>
  </>
  );
};

export default DownloadCSVButton;
